




























































import Vue from 'vue'
import moment from 'moment'
import { mapState } from 'vuex'
import { TranslateResult } from 'vue-i18n'

export default Vue.extend({
  props: {
    value: String,
    year: Boolean,
    min: {
      type: String,
      required: false,
      default: undefined,
    },
    max: {
      type: String,
      required: false,
      default: undefined,
    },
    'event-color': {
      type: String,
      required: false,
      default: undefined,
    },
    events: {
      type: [Array, Function],
      required: false,
      default: undefined,
    },
    readonly: Boolean,
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      time: '00:00',
      menu: false,
    }
  },
  computed: {
    ...mapState(['profile']),
    dateValue(): string {
      return moment(this.value || new Date())
        .toISOString()
        .substring(0, 10)
    },
  },
  watch: {
    menu(val) {
      if (this.year) {
        val &&
          setTimeout(() => ((this.$refs.picker as any).activePicker = 'YEAR'))
      }
    },
    value(value: string) {
      if (!value) {
        return
      }
      const datetime = moment(value)
      this.date = datetime.format('YYYY-MM-DD')
      this.time = datetime.format('HH:mm')
    },
  },
  methods: {
    formatDate(date: string): string | TranslateResult {
      if (!date) {
        return ''
      }
      moment.locale(this.profile.language)
      return moment(date).format('MMM DD YYYY hh:mm a')
    },
    onDateInput(value: string) {
      this.$emit('input', moment(value + ' ' + this.time).toISOString())
    },
    onTimeInput(value: string) {
      this.$emit('input', moment(this.date + ' ' + value).toISOString())
    },
  },
})
